import React, { useState } from 'react';
import type { Swiper as SwiperType } from 'swiper';
import SwiperCore, {
  Navigation,
  Scrollbar,
  Mousewheel,
  Pagination,
  Thumbs,
  Keyboard,
  FreeMode,
} from 'swiper';
import GallerySwiper from 'src/components/GallerySwiper/GallerySwiper';
import type { PopupSwiperProps } from 'src/components/GallerySwiper/types';
import { PopupSwiper } from 'src/components/GallerySwiper/components/PopupSwiper';
import classnames from 'classnames';
import { paramsSwiperReviewCard } from './swiperParams';
import type { GallerySwiperReviewCardMobileProps } from './types';

import styles from './gallerySwiperReviewCard.module.css';

SwiperCore.use([
  Navigation,
  Scrollbar,
  Mousewheel,
  Pagination,
  Thumbs,
  Keyboard,
  FreeMode,
]);

const GallerySwiperReviewCardMobile = ({
  images,
  title,
  className,
  disableOpenGallery,
}: GallerySwiperReviewCardMobileProps) => {
  const galleryImages = images.map((image, index) => ({
    fullImage: image.full,
    smallImage: image.x180 ?? image.full,
    id: index,
  }));
  const [opened, setOpened] = useState(false);
  const [realIndexSlide, setRealIndexSlide] = useState(0);
  const [swiperGallery, setSwiperGallery] = useState<null | SwiperType>(null);
  const [swiperGalleryPopup, setSwiperGalleryPopup] =
    useState<null | SwiperType>(null);

  const openPopup = (index: number) => {
    setRealIndexSlide(index);
    setOpened(true);
  };
  const closePopup = () => {
    setOpened(false);
  };
  const changeSlide = () => {
    if (swiperGalleryPopup && swiperGallery && !swiperGalleryPopup.destroyed) {
      swiperGallery.slideTo(swiperGalleryPopup.activeIndex);
    }
  };
  const swiperParams = disableOpenGallery
    ? { ...paramsSwiperReviewCard, allowTouchMove: false }
    : paramsSwiperReviewCard;
  const swiperPopupProps: PopupSwiperProps = {
    opened,
    images: galleryImages.map((image) => image.fullImage),
    title,
    isMobile: true,
    swiperGalleryPopup,
    realIndexSlide,
    closePopup,
    setSwiperGalleryPopup,
    changeSlide,
  };
  return (
    <div
      className={classnames(
        styles.container,
        styles.containerMobile,
        className,
      )}
    >
      <GallerySwiper
        images={galleryImages}
        isMobile
        title={title}
        paramsSwiper={swiperParams}
        setSwiperGallery={setSwiperGallery}
        isLooped={false}
        openPopup={disableOpenGallery ? undefined : openPopup}
        realIndexSlide={realIndexSlide}
      />
      <PopupSwiper {...swiperPopupProps} />
    </div>
  );
};

export default GallerySwiperReviewCardMobile;
